import React from 'react';
import {View, Text, TouchableOpacity, StyleSheet} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {ToggleAddTag} from '../../../actions/tagPriorityActions';

export const AddTagButton = ({title, onDateFilterPress}) => {
  const dispatch = useDispatch();
  const {displayAddTag} = useSelector(state => state.tagPriority);
  const handleOnPress = () => {
    dispatch(ToggleAddTag(!displayAddTag));
  };

  return (
    <View style={styles.addTagSection}>
      <View style={styles.buttonsRow}>
        <TouchableOpacity
          testID="dateFilterButton"
          onPress={onDateFilterPress}
          style={styles.buttonContainer}
        >
          <i className="icon-filter" style={styles.iconButton}></i>
          <Text style={styles.buttonText}>Date Filter</Text>
        </TouchableOpacity>

        <TouchableOpacity
          testID="addTagButton"
          onPress={handleOnPress}
          style={styles.buttonContainer}
        >
          <i className="icon-plus" style={styles.iconButton}></i>
          <Text style={styles.buttonText}>{title}</Text>
        </TouchableOpacity>
      </View>

      {title !== 'Add user card' && (
        <View style={styles.standByContainer}>
          <Text style={[styles.addTagText, {textAlign: 'center'}]}>
            Stand by List
          </Text>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  addTagSection: {
    display: 'flex',
    alignItems: 'center',
    marginVertical: '2%'
  },
  buttonsRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 20,
    marginTop: 10
  },
  buttonContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 15,
    paddingVertical: 8,
    backgroundColor: '#313943',
    borderRadius: 8,
    minWidth: 80
  },
  iconButton: {
    fontSize: 20,
    color: '#FFFFFF',
    marginBottom: 4
  },
  buttonText: {
    fontSize: 11,
    color: '#E0E7EF',
    fontFamily: 'Poppins_300Light',
    textAlign: 'center'
  },
  iconPlus: {
    color: '#979B9F',
    fontSize: 40,
    marginTop: 10
  },
  addTagText: {
    color: '#D1D2D4',
    fontSize: 16,
    fontWeight: 'bold'
  },
  standByContainer: {
    width: '100%',
    backgroundColor: '#262B31',
    padding: 5,
    marginTop: 5
  }
});
